import axios from 'axios';
import AppConfig from '../AppConfig';
import setupInterceptors from './setupInterceptor';

const healthCheckupAxiosInstance = axios.create({
  baseURL: AppConfig.EMPLOYEE_EXPERIENCE_BASE_URL as string,
});

setupInterceptors(healthCheckupAxiosInstance);

export default healthCheckupAxiosInstance;
